import {
    FileTemplatePanel,
    TFileTemplatePanel
} from '~/components/Templates/types/templates.types';
import {
    PANEL_TO_CREATE_TEMPLATE_TYPE,
    ANGULAR_TEMPLATE_KEYS
} from '~/components/Templates/components/FileTemplates/AngularTemplatesKeys';

export const getClickShareTemplateSource = () => {
    return window.location.pathname.includes('my-templates')
        ? 'my_templates'
        : 'builder';
};

export function isValidLegacyTemplateType(
    value: string
): value is FileTemplatePanel {
    return Object.values(FileTemplatePanel).includes(
        value as FileTemplatePanel
    );
}

export const getTypeText = (type: TFileTemplatePanel) => {
    const createTemplateType = PANEL_TO_CREATE_TEMPLATE_TYPE[type];
    const currType = ANGULAR_TEMPLATE_KEYS[createTemplateType];
    return currType?.name;
};
